import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pricingRuleForm.filtersFormSection.title',
    defaultMessage: 'Filters',
    description: 'Title of the filters form section of the pricing rule form',
  },
  filterTypes: {
    sku: {
      id: 'pricingRuleForm.filterTypes.sku',
      defaultMessage: 'SKU',
      description: 'label of the filter type sku',
    },
    filter: {
      id: 'pricingRuleForm.filterTypes.filter',
      defaultMessage: 'Filter',
      description: 'label of the filter type filter',
    },
    isDiscounted: {
      id: 'pricingRuleForm.filterTypes.isDiscounted',
      defaultMessage: 'Discounted',
      description: 'label of the filter type discounted',
    },
    per: {
      id: 'pricingRuleForm.filterTypes.per',
      defaultMessage: 'Per',
      description: 'label of the filter type per',
    },
  },
  operators: {
    in: {
      id: 'operators.in',
      defaultMessage: 'In',
      description: 'label of the operator in',
    },
    gte: {
      id: 'operators.gte',
      defaultMessage: 'Greater than or equal to',
      description: 'label of the operator gte',
    },
    gt: {
      id: 'operators.gt',
      defaultMessage: 'Greater than',
      description: 'label of the operator gt',
    },
    lte: {
      id: 'operators.lte',
      defaultMessage: 'Lesser than or equal to',
      description: 'label of the operator lte',
    },
    lt: {
      id: 'operators.lt',
      defaultMessage: 'Lesser than',
      description: 'label of the operator lt',
    },
  },
};

export default defineMessages(translations);
